/**
 * PageFilters - Unboxed filter/search row on the page background
 */

import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const FiltersRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1.5),
  flexWrap: "wrap",
  flexDirection: "column",
  marginBottom: theme.spacing(1.5),
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
}));

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
const PageFilters = ({ children, ...rest }) => (
  <FiltersRoot data-testid="page-filters" {...rest}>
    {children}
  </FiltersRoot>
);

export default PageFilters;
